var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGanttChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 6L11.3333 3.06667C11.3333 2.6933 11.3333 2.50661 11.2607 2.36401C11.1968 2.23857 11.0948 2.13658 10.9693 2.07266C10.8267 2 10.64 2 10.2667 2L3.06667 2C2.69327 2 2.5066 2 2.364 2.07266C2.23853 2.13658 2.1366 2.23857 2.07267 2.36401C2 2.50661 2 2.6933 2 3.06667L2 6M2 6L2 10M2 6L12.9333 6C13.3067 6 13.4934 6 13.636 6.07266C13.7614 6.13658 13.8634 6.23857 13.9273 6.36401C14 6.50661 14 6.69327 14 7.06667L14 8.93333C14 9.30673 14 9.4934 13.9273 9.636C13.8634 9.76147 13.7614 9.8634 13.636 9.92733C13.4934 10 13.3067 10 12.9333 10L2 10M2 10L2 12.9333C2 13.3067 2 13.4934 2.07267 13.636C2.1366 13.7615 2.23853 13.8634 2.364 13.9273C2.5066 14 2.69327 14 3.06667 14L7.6 14C7.9734 14 8.16007 14 8.30267 13.9273C8.42813 13.8634 8.53007 13.7615 8.594 13.636C8.66667 13.4934 8.66667 13.3067 8.66667 12.9333L8.66667 10",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanttChart);
export default __webpack_public_path__ + "static/media/gantt-chart.bb9dd9b41d841252eec29a5171738eb0.svg";
export { ForwardRef as ReactComponent };